<template>
  <div id="app" v-if="display">
    <layout-top></layout-top>
    <router-view/>
    <send-bill></send-bill>
  </div>
</template>
<style src="@/scss/app.scss" lang="scss"></style>
<script>
import LayoutTop from '@/components/LayoutTop/LayoutTop.vue'
import SendBill from '@/components/SendBill/SendBill.vue'

export default {
    name: 'App',

    data() {
        return {
            display: true
        }
    },

    components: {
        'layout-top': LayoutTop,
        'send-bill': SendBill
    },

    created() {
        // query params
        const query = location.search.replace(/\%2F/gi, '/').substr(1)
        const querySplit = query.split('&')
        let paramsObj = {}
        if (querySplit && querySplit.length) {
            querySplit.map(value => value.split('=')).forEach(params => {
                if (params[0] && params[1]) {
                    paramsObj[params[0]] = params[1]
                }
            })
        }

        // extra params assign
        let extraParams = {}
        Object.keys(paramsObj).forEach(key => {
            if (key !== 'offerta') {
                extraParams[key] = paramsObj[key]
            }
        })
        this.$store.commit('extraParams', extraParams)

        // redirect to home if no offer param
        if (!paramsObj.offerta) {
            window.location.href = this.$store.state.saveAndRedirectUrl
            return
        }

        // test token
        let token = null
        let objToken = JSON.parse(localStorage.getItem('agsmToken'))
        let newToken = false
        const now = new Date().getTime()

        if (objToken && objToken.timestamp) {
            const timeDiff = 1000 * 60 * 60 * 60 * 24 * 15 // 15 days
            if ((now - timeDiff) > objToken.timestamp) {
                objToken = null // generate a new token
            } else {
                token = objToken.value // set saved token
                this.$store.commit('token', objToken.value)
            }
        }

        // create new token if offer is not equal to saved offer
        if (localStorage.getItem('agsmOffer') !== paramsObj.offerta) {
            objToken = null
        }

        // new token
        if (!objToken) {
            newToken = true
            token = `agsm_${now}_${Math.floor(Math.random() * 100)}`
            objToken = {
                value: token,
                timestamp: now,
                retrieveData: false
            }
            localStorage.setItem('agsmToken', JSON.stringify(objToken))
            localStorage.setItem('agsmOffer', paramsObj.offerta)
            this.$store.commit('token', token)
        }

        // retrieve data
        if (!newToken && objToken.retrieveData) {
            this.$apiCall(`/StepFunnelWeb/GetDataByToken?tokenId=${token}`)
                .then(data => {
                    let fieldsData = {}
                    if (data.fields && data.fields.length) {
                        data.fields.forEach(el => {
                            let value = el.valueField
                            if (value === 'true') {
                                value = true
                            }
                            if (value === 'false') {
                                value = false
                            }
                            fieldsData[el.field] = value
                            this.$store.commit('formValues', fieldsData)
                        })
                    }
                })
        }

        // offer
        if (paramsObj.offerta) {
            this.$apiCall(`/StepFunnelWeb/GetStepInit?url=${paramsObj.offerta}`)
                .then(data => {
                    if (data && data.prodotto && data.tServizio && data.tTariffa) {
                        this.$store.commit('init', data)
                    } else {
                        this.display = false
                        console.error('no offer')
                    }
                })
        } else {
            this.display = false
            console.error('no offer')
        }

        // sellers
        this.$apiCall('/StepFunnelWeb/GetListVenditori')
            .then(data => {
                if (data && data.length) {
                    const sellers = data.map(value => value.venditore)
                    this.$store.commit('sellers', sellers)
                } else {
                    console.warn('no sellers loaded')
                }
            })

        // provinces
        this.$apiCall('/StepFunnelWeb/GetListProvince')
            .then(data => {
                if (data && data.length) {
                    this.$store.commit('provinces', data)
                } else {
                    console.warn('no sellers loaded')
                }
            })
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue